module.exports = __webpack_public_path__ + "static/media/voting-closed.fd8e3f77.png";